import * as React from "react";
import { useTranslation } from "react-i18next";
import { Row } from "components/bootstrap";
import { DocumentTitle } from "components/common";
import PageNavigation from "components/common/PageNavigation";
import { PAGE_NAV_TITLE as SYSTEM_PAGE_NAV_TITLE } from "components/system-overview/bindings";
import HealthModule from "./HealthModule";
const HealthPage = () => {
  const { t } = useTranslation("enterprise_license");
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: t("health.page_title") }, /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(PageNavigation, { page: SYSTEM_PAGE_NAV_TITLE })), /* @__PURE__ */ React.createElement(HealthModule, null)));
};
export default HealthPage;
